import React, { Component } from "react";
import { Header, H1 } from "./style"
export default class Title extends Component {
  render() {
    return (
      <Header>
        <H1>The Card Game Maker</H1>
      </Header>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Title/index.js